<template>
  <div class="card flex items-start gap-6 px-5 py-4">
    <span class="flex items-center gap-2.5">
      <span class="h-7 w-2.5 rounded-[3px]" :style="{ background: color }" />
      <span class="flex flex-col">
        <span class="text-xl font-bold leading-tight text-gray-900">{{ poNumber }}</span>
        <span v-if="vendorName" class="text-[13px] text-gray-500">{{ vendorName }}</span>
      </span>
    </span>
    <span class="w-px self-stretch bg-gray-200" />
    <span class="flex flex-col gap-0.5">
      <span class="field-label">Currently scheduled</span>
      <span v-if="loading" class="text-sm text-gray-400">Loading…</span>
      <span v-else-if="schedule === null" class="text-sm text-gray-400">Not available</span>
      <span v-else-if="schedule.length === 0" class="text-sm text-gray-500">Not scheduled</span>
      <span v-else class="flex flex-col gap-1">
        <span v-for="week in schedule" :key="week.weekStart" class="inline-flex items-center gap-2">
          <span class="min-w-[44px] text-sm font-semibold tabular-nums text-gray-900">Wk {{ isoWeekNumber(week.weekStart) }}</span>
          <QuantityPill v-for="portion in week.portions" :key="portion.typeCode" :code="portion.typeCode" :quantity="portion.quantity" />
        </span>
      </span>
    </span>
    <span class="flex flex-col gap-0.5">
      <span class="field-label">Changes</span>
      <span class="text-sm tabular-nums text-gray-900">{{ total ?? '…' }}</span>
    </span>
    <span class="ml-auto inline-flex gap-2">
      <router-link class="btn-secondary px-3 py-1.5 text-[13px]" :to="{ path: '/scheduling', query: boardQuery }">Open on board</router-link>
      <router-link class="btn-secondary px-3 py-1.5 text-[13px]" :to="{ path: '/capacity-calendar', query: { po: poNumber } }">Open in calendar</router-link>
    </span>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import QuantityPill from '@/components/activity/QuantityPill.vue';
  import { isoWeekNumber } from '@/utils/isoWeek';

  const props = defineProps<{
    poNumber: string;
    vendorName: string | null;
    color: string;
    schedule: { weekStart: string; portions: { typeCode: string; quantity: number }[] }[] | null;
    total: number | null;
    loading: boolean;
    // The block the latest change touched; the board selects it rather than the PO's first week.
    assignmentId: string | null;
  }>();

  const boardQuery = computed(() => (props.assignmentId ? { po: props.poNumber, assignmentId: props.assignmentId } : { po: props.poNumber }));
</script>

<style scoped>
  .field-label {
    @apply text-[11px] font-semibold uppercase tracking-wide text-gray-500;
  }
</style>
